import { string } from "yup"

export default string()
  .required("Required")
  .max(20, "Must be 20 characters or less")
  .min(6, "Must be 6 characters or more")
